import React from 'react';
import ServiceCarousel from './ServiceCarousel';
import { usePopularServices, toArray } from '../../services/hooks/useCatalog';

const PopularServices = () => {
  const { data, isLoading } = usePopularServices();
  const items = toArray(data);

  return (
    <ServiceCarousel
      title="Popular Services"
      subtitle="Most-booked services near you"
      items={items}
      loading={isLoading}
    />
  );
};

export default PopularServices;
